import { FC } from 'react';

import LandscapeIcon from '@mui/icons-material/Landscape';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const WhatToSeeCard: FC = () => (
  <ToolCard
    icon={<LandscapeIcon fontSize="large" />}
    title="Ką pamatyti"
    description="Ką pamatyti straipsnių administravimas"
    action={
      <Button href="what-to-sees" startIcon={<LandscapeIcon />} size="small">
        Administruoti
      </Button>
    }
  />
);

export default WhatToSeeCard;
